import moment from 'moment';

const getLocale = () => {
    // Por lo que parece, por defecto, en español, solo sale el punto separando millares si la cantidad es más de 10.000
    // return 'es-ES';
    return 'de-DE';
};

const filters = {
    /**
     * @param {*} value to filter
     * @return {moment} formated date
     */
    yuriDateFormat(value) {
        let date = new Date(value);
        const offset = -(date.getTimezoneOffset() / 60);
        return moment(date).utcOffset(offset).format('DD-MMM-YYYY | HH:mm [h]');
    },
    /**
     * @param {*} value to filter
     * @return {moment} formated date
     */
    yuriSimpleDate(value) {
        return moment(value).format('DD-MMM-YYYY');
    },
    /**
     * @param {*} value to filter
     * @param {Number} decimals length
     * @return {String} formated number
     */
    yuriDecimals(value, decimals = 6) {
        return value
            ? Number(value).toLocaleString(getLocale(), {
                  maximumFractionDigits: decimals,
                  minimumFractionDigits: decimals
              })
            : 0;
    },
    /**
     * @param {*} value to filter
     * @return {String} formated number
     */
    yuriCurrency(value, maxDigits = 2, minDigits = 2) {
        // return value ? Number(value).toLocaleString('es', { style: 'currency', currency: 'EUR' }) : '-';
        // Quitado símbolo de moneda a petición de Fernando
        return value || value == 0
            ? Number(value).toLocaleString(getLocale(), {
                  maximumFractionDigits: maxDigits,
                  minimumFractionDigits: minDigits
              })
            : '-';
    },
    /**
     * @param {*} value to filter
     * @return {String} formated number
     */
    yuriLongCurrency(value) {
        if (value) {
            const numberValue = Number(value).toLocaleString(getLocale(), {
                maximumFractionDigits: '6',
                minimumFractionDigits: '6'
            });
            // return `${numberValue} €`;
            // Quitado símbolo de moneda a petición de Fernando
            return `${numberValue}`;
        } else {
            return '-';
        }
    }
};

export default filters;
